function updateErrorClass(el, binding, vnode) {
  const dirty = !!binding.value || el.$localDirty;
  const errors = vnode.context.errors || [];
  let show = false;

  const validationOutput = el.getElementsByClassName('validation-output')[0];

  // In this time el don't have to be fully loaded and
  // validation-output element don' have to exists.
  if (!validationOutput) return;

  let foundError = false;
  Array.prototype.slice.call(validationOutput.childNodes)
    .filter((ch) => ch.getAttribute && (`${ch.getAttribute('class')}`).indexOf('error') >= 0)
    .forEach((e) => {
      if (!foundError && dirty && errors.indexOf(e.getAttribute('id')) >= 0) {
        foundError = true;
        e.style.display = 'block';
        show = true;
      } else {
        e.style.display = 'none';
      }
    });

  const cls = el.getAttribute('class') || '';
  if (foundError) {
    el.classList.add('has-error');
    el.classList.remove('is-valid');
  }
  if (!foundError) {
    el.classList.remove('has-error');
    el.classList.add('is-valid');
  }
}

function insertedErrorClass(el, binding, vnode) {
  el.$handler = () => { el.$localDirty = true; }; // eslint-disable-line
  el.$dirtyClassHandler = () => { // eslint-disable-line
    el.classList.add('input-dirty');
  };

  el.addEventListener('focusin', el.$handler);
  const input = el.getElementsByTagName('input')[0];
  if (input) input.addEventListener('blur', el.$dirtyClassHandler);

  updateErrorClass(el, binding, vnode);
}

function unbindErrorClass(el) {
  if (el.$handler) el.removeEventListener('focusin', el.$handler);
  if (el.$dirtyClassHandler) el.removeEventListener('blur', el.$dirtyClassHandler);
  delete el.$handler; // eslint-disable-line
  delete el.$dirtyClassHandler; // eslint-disable-line
}

export default {
  inserted: insertedErrorClass,
  update: updateErrorClass,
  unbind: unbindErrorClass,
}
